import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'in0032',
    ecrans: ['00-2']
});
